<div class="glass context-holder">
    <div class="px-3 py-4 d-flex flex-column align-items-center ">
        <div class="image mx-5 my-3">
            <base64-image [base64String]="profileImageB64"></base64-image>
        </div>
        <div class="profile-name">{{ user?.display_name }}</div>
        <div class="profile-status">{{ user?.tag_line }}</div>
    </div>
    <ul class="list-group list-group-flush mb-3">
        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            (click)="viewProfile()">
            <div>View Profile (coming soon)</div>
            <fa-icon [icon]="iconsService.faIconsRegular.faUser"></fa-icon>
        </li>
        <li class="list-group-item list-group-item-action pointer d-flex justify-content-between align-items-center"
            (click)="openChat()">
            <div>Open chat</div>
            <fa-icon [icon]="iconsService.faIconsRegular.faMessage"></fa-icon>
        </li>
<!--        <li class="list-group-item list-group-item-action pointer">A second item</li>-->
<!--        <li class="list-group-item list-group-item-action pointer">A third item</li>-->
<!--        <li class="list-group-item list-group-item-action pointer">A fourth item</li>-->
<!--        <li class="list-group-item list-group-item-action pointer">And a fifth one</li>-->
    </ul>
</div>
